import SSOPaymentDeposit from './SSOPaymentDeposit';

export default SSOPaymentDeposit;
